// Brand palette derived from the MYC app icon gradient (#6366F1 -> #4338CA).
// Shared across the portal chrome (sidebar, top bar, layout, login) so the
// UI reads as one consistent product rather than per-page ad hoc colors.
const theme = {
  primary: '#4F46E5',
  primaryDark: '#4338CA',
  primaryDarker: '#3730A3',
  primaryLight: '#EEF2FF',
  primaryLightBorder: '#C7D2FE',
  primarySoftBorder: '#E0E7FF',
  gradient: 'linear-gradient(135deg, #6366F1 0%, #4338CA 100%)',
  gradientSoft: 'radial-gradient(circle at top left, #EEF2FF 0%, #F8FAFC 45%, #F9FAFB 100%)',
};

export default theme;
